import React, { useState } from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import ProductCarousel from "./components/ProductCarousel";
import Craftsmanship from "./components/Craftsmanship";
import Testimonials from "./components/Testimonials";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import SizeGuidePopup from "./components/SizeGuidePopup";
import LiveChat from "./components/LiveChat";

function App() {
  const [sizeGuideOpen, setSizeGuideOpen] = useState(false);

  return (
    <div className="App">
      <Navigation onSizeGuideClick={() => setSizeGuideOpen(true)} />
      <Hero />
      <ProductCarousel />
      <Craftsmanship />
      <Testimonials />
      <Newsletter />
      <Footer />
      <SizeGuidePopup isOpen={sizeGuideOpen} onClose={() => setSizeGuideOpen(false)} />
      <LiveChat />
      <Toaster />
    </div>
  );
}

export default App;
